const experiments = [
  // {
  //   key: 'cart-upsell-format',
  //   label: 'Cart Upsell Format',
  //   variants: [
  //     {
  //       id: 'control',
  //       label: 'Horizontal',
  //     },
  //     {
  //       id: 'variant',
  //       label: 'Vertical',
  //     },
  //   ],
  // }
]

export default defineNuxtPlugin(() => {
  const abTestStore = useAbTestStore()

  if (import.meta.server) {
    const headers = useRequestHeaders()

    const url = useRequestURL()
    abTestStore.INIT({ headers, url })
  }

  return {
    name: 'abt',
    provide: {
      abt: {
        variant: (key) => abTestStore.tests?.[key]?.value,
        active() {
          return experiments
            .filter((experiment) => experiment.key in abTestStore.tests)
            .map((experiment) => {
              return {
                ...experiment,
                activeVariant: abTestStore.tests[experiment.key]?.value,
              }
            })
        },
      },
    },
  }
})
